import { loader as loaderConstants } from '@/store/constants';

const { SET_LOADER_VISIBILITY, SET_LOADER_MESSAGE } = loaderConstants.mutations;

const initialState = {
  loaderIsVisible: true,
  loaderContent: undefined,
};

// getters
const getters = {};

// actions
const actions = {
  setLoaderVisiblity({ commit }, { isVisible, content } = { isVisible: false }) {
    commit(SET_LOADER_VISIBILITY, { isVisible });
    commit(SET_LOADER_MESSAGE, isVisible ? { content } : {});
  },
  setLoaderMessage({ commit }, { content } = {}) {
    commit(SET_LOADER_MESSAGE, { content });
  },
};

// mutations
/* eslint-disable no-param-reassign */
const mutations = {
  [SET_LOADER_VISIBILITY](state, { isVisible } = { isVisible: false }) {
    state.loaderIsVisible = isVisible;
  },
  [SET_LOADER_MESSAGE](state, { content } = {}) {
    state.loaderContent = content;
  },
};
/* eslint-enable no-param-reassign */

export default {
  state: initialState,
  getters,
  actions,
  mutations,
};
